<!-- @file 答题卡-题目答案。 -->

<template>
  <div>
    <!-- 评分 -->
    <template v-if="questionResult.content.type === 'S'">
      <div class="plv-iar-answer-card-answer-default__score__result">
        <IconTipWarn :size="60" color="#ff8142" class="plv-iar-answer-card-answer-default__score__result__icon"/>
        <p class="plv-iar-answer-card-answer-default__score__result__tips">{{ iarTrans('answerCard.pointsEnd') }}</p>
        <p class="plv-iar-answer-card-answer-default__score__result__question">{{ questionType(question) }} {{ question.name }}</p>
        <p class="plv-iar-answer-card-answer-default__score__result__avg">
          {{ iarTrans('answerCard.averageScore') }} <span>{{ questionResult.result.avgScore }}</span> {{ iarTrans('answerCard.point') }}
        </p>
      </div>
    </template>

    <!-- 投票 -->
    <template v-else-if="questionResult.content.type === 'V'">
      <div>
        <p class="plv-iar-answer-card-answer-default__question">{{ questionType(question) }} {{ question.name }}</p>
        <ul class="plv-iar-answer-card-answer-default__options">
          <li
            v-for="(option, index) in options"
            :key="index"
            class="plv-iar-answer-card-answer-default__option plv-iar-answer-card-answer-default__option--vote"
          >
            <div class="plv-iar-answer-card-answer-default__option-inner-wrap">
              <label>
                <div
                  class="plv-iar-answer-card-answer-default__option--vote__percent"
                  :style="{
                    width: `${getPercent(index)}%`,
                  }"
                ></div>
                <span class="plv-iar-answer-card-answer-default__option-content">{{ getOptionText(question, index) }}</span>
                <span class="plv-iar-answer-card-answer-default__options__num">
                  <span>{{ getOptionSubmitCount(index) }}</span>{{ iarTrans('answerCard.people') }}({{ getPercent(index) }}%)
                </span>
              </label>
            </div>
          </li>
        </ul>
      </div>
    </template>

    <!-- 多选、单选 -->
    <template v-else>
      <div>
        <p class="plv-iar-answer-card-answer-default__question">{{ questionType(question) }} {{ question && question.name }}</p>
        <ul class="plv-iar-answer-card-answer-default__options">
          <li
            v-for="(option, index) in options"
            :key="index"
            class="plv-iar-answer-card-answer-default__option"
            :class="{
              'plv-iar-answer-card-answer-default__option--right': isRightOption(index),
              'plv-iar-answer-card-answer-default__option--wrong': isWrongChoice(index),
            }"
          >
            <div class="plv-iar-answer-card-answer-default__option-inner-wrap">
              <label>
                <span class="plv-iar-answer-card-answer-default__option-content">{{ getOptionText(question, index) }}</span>
                <IconTipRight
                  v-if="isRightOption(index)"
                  class="plv-iar-answer-card-answer__icon"
                  :size="16"
                  color="#0a8dff" />
                <IconTipWrong
                  v-else-if="isWrongChoice(index)"
                  class="plv-iar-answer-card-answer__icon"
                  :size="16"
                  color="#fb7272" />
                <span v-if="question.type === 'R'" class="plv-iar-answer-card-answer-default__options__num">
                  <span>{{ getOptionSubmitCount(index) }}</span>{{ iarTrans('answerCard.people') }}({{ getPercent(index) }}%)
                </span>
              </label>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin';
import IconTipRight from '../../../icon-components/icons/icon-tip-right';
import IconTipWrong from '../../../icon-components/icons/icon-tip-wrong';
import IconTipWarn from '../../../icon-components/icons/icon-tip-warn';

export default {
  mixins: [mixin],
  components: {
    IconTipRight,
    IconTipWrong,
    IconTipWarn
  },
};
</script>

<style lang="scss">

.plv-iar-answer-card-answer-default__score__result {
  font-size: 14px;
  color: #333;
  text-align: center;
  &__tips {
    margin: 0;
    margin-top: 20px;
  }
  &__question {
    margin: 0;
    margin-top: 20px;
    color: #666;
  }
  &__avg {
    margin: 0;
    margin-top: 8px;
    margin-bottom: 30px;
    span {
      color: #45ACFF;
      font-size: 24px;
      font-weight: 600;
    }
  }
}

.plv-iar-answer-card-answer-default__question {
  margin: 0;
  margin-bottom: 20px;
  color: #333333;
  font-size: 14px;
  line-height: 1.5;
}

.plv-iar-answer-card-answer-default__options {
  margin: 0;
  list-style: none;
  padding: 0;
  display: table;
}

.plv-iar-answer-card-answer-default__option {
  padding-right: 31px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333333;
  display: table-row;

  .plv-iar-answer-card-answer-default__option-inner-wrap {
    position: relative;
    display: table-cell;
    padding-bottom: 20px;
    padding-right: 50px; // 留给选项人数的宽度
  }

  label {
    position: relative;
    display: block;
    padding: 8px 48px 12px 16px;
    min-width: 96px;
    max-width: 400px;
    box-sizing: border-box;
    background-color: #EDF1F7;
    border: none;
    color: #546E7A;
    border-radius: 20px;
    cursor: default;
    user-select: none;

    .plv-iar-answer-card-answer-default__option-content {
      font-size: 14px;
      line-height: 1.6;
    }
  }

  &--right {
    label {
      background-color: #C0E3FF;
      color: #2196F3;
    }
  }

  &--wrong {
    label {
      background-color: #FFE3E3;
      color: #E45B5B;
    }
  }
}

.plv-iar-answer-card-answer-default__options__num {
  position: absolute;
  top: 50%;
  left: 100%;
  display: block;
  margin-left: 8px;
  margin-top: -10px;
  font-size: 14px;
  white-space: nowrap;
  color: #546E7A;
  span {
    color: #2196F3;
  }
}

.plv-iar-answer-card-answer-default__option--vote {
  label {
    position: relative;
    background: #fff;
    border: 1px solid #C0E3FF;
    padding-right: 16px;
    .plv-iar-answer-card-answer-default__option--vote__percent {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background: #C0E3FF;
      border-radius: 20px;
    }
    .plv-iar-answer-card-answer-default__option-content {
      position: relative;
    }
  }
}
.plv-iar-answer-card-answer__icon {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translate(0, -50%);
}
.plv-iar-answer-card-answer-default__score__result__icon {
  display: block;
  margin-top: 40px;
  margin-bottom: 20px;
}
</style>
